const skills = [
  { icon: 'ri-search-eye-line', title: 'Диагностика конфликта', desc: 'Определять причину, участников, интересы и реальную проблему, которая стоит за спором, а не только его внешние проявления.' },
  { icon: 'ri-emotion-normal-line', title: 'Управление эмоциями', desc: 'Сохранять рабочую позицию и помогать собеседникам выходить из эмоциональной реакции в конструктивный разговор.' },
  { icon: 'ri-chat-3-line', title: 'Сложный разговор', desc: 'Начинать разговор о проблеме без обвинений и нападения, удерживая фокус на задаче, а не на личности.' },
  { icon: 'ri-user-voice-line', title: 'Активное слушание', desc: 'Понимать позицию сотрудника, не соглашаясь автоматически с ней, и проверять, что услышал собеседника правильно.' },
  { icon: 'ri-compass-3-line', title: 'Работа с интересами', desc: 'Отделять заявленную позицию от реальной потребности или интереса, который за ней стоит.' },
  { icon: 'ri-shake-hands-line', title: 'Переговоры', desc: 'Находить решение, которое учитывает интересы сторон и задачи бизнеса, а не просто «продавливает» чью-то точку зрения.' },
  { icon: 'ri-message-2-line', title: 'Обратная связь', desc: 'Говорить о конкретном поведении и его последствиях, а не о характере или намерениях человека.' },
  { icon: 'ri-team-line', title: 'Медиация', desc: 'Помогать сторонам самостоятельно выработать рабочее решение, не подменяя их собственным.' },
  { icon: 'ri-file-check-line', title: 'Фиксация договорённостей', desc: 'Переводить разговор в конкретные действия, сроки и ответственность, чтобы решение не осталось «на словах».' },
  { icon: 'ri-check-double-line', title: 'Контроль', desc: 'Проверять, что конфликт действительно разрешён, а не просто временно прекратился.' },
];

export default function SkillsDeveloped() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Чему учатся руководители
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практические навыки управления конфликтами, которые руководитель применяет в реальной работе
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {skills.map((s) => (
            <div key={s.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}